module.exports = __webpack_public_path__ + "static/img/GoDaddy2.914e6cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faq/GoDaddy2.png
// module id = 1773
// module chunks = 5